export default "__VITE_ASSET__D55ru8Ih__"